/* @flow */

export default class SendVerificationEmailRequest {
  email: string;

  constructor(email: string) {
    this.email = email;
  }
}
